import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numberFormat]'
})
export class NumberFormatDirective implements OnInit {
  constructor(private el: ElementRef, private control: NgControl) {}

  ngOnInit() {
    if (this.control && this.control.value) {
      this.formatValue(this.control.value);
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    // Remove non-numeric characters except decimal point
    const rawValue = value.replace(/[^\d.]/g, '');
    
    // Format with commas
    this.formatValue(rawValue);
  }
  
  formatValue(value: string | null) {
    if (value === null || value === undefined || value === '') return;
    
    // Split by decimal point
    const parts = value.toString().split('.');
    
    // Format the whole number part with commas
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    // Join back with decimal part if it exists
    const formattedValue = parts.join('.');
    
    // Set the formatted value in the form control
    this.control.control.setValue(formattedValue, { emitEvent: false });
    
    // Also update the input element value
    this.el.nativeElement.value = formattedValue;
  }
  
  // Also handle blur to ensure formatting is applied when focus leaves
  @HostListener('blur')
  onBlur() {
    if (this.control && this.control.value) {
      // Remove existing commas before formatting
      const rawValue = this.control.value.toString().replace(/,/g, '');
      this.formatValue(rawValue);
    }
  }
}